<i18n lang="yaml">
zh:
  short_story_template: "短篇 故事设置 模板"
  select_story_template: "选择故事模板"
  no_template: "不使用故事套路模板"
  free_create: "自由创作，不受约束！"
  template_difficulty: "模板难度"
  story_type: "故事类型"
  type: "类型"
  inspiration_helper: "灵感助手"
  template_routine: "模板套路"
  role_description: "角色说明"
  routine_tip: "说明：以上为套路说明，请根据套路说明植入想要的故事事件"
  ai_generate: "AI生成"
  writing_perspective: "写作视角"
  story_style: "故事文风"
  style: "文风"
  reference_word_count: "参考章节字数"
  ai_wordcount_tip: "由于AI算法的原因，目前无法精准控制生成的字数，生成的内容只能保持在一个大致的范围内。"
  creative_guide: "创意引导"
  story_elements: "故事元素"
  element_placeholder: "非必填，多个用逗号分隔"
  change_another: "换一换"
  hot_topics: "时下热点"
  hot_placeholder: "可选，多个用逗号分隔"
  other_ideas: "其它想法"
  other_ideas_placeholder: "请描述你想创作的故事…可以是简单的一句话或者是一大段设定"
  fill_event: "请填写完整的相关事件"
  select_story_type: "请选择故事类型"
  select_perspective: "请选择写作视角"
  select_style: "请选择故事文风"
  select_wordcount: "请选择参考章节字数"
  select_template: "请选择模板"
  answer_in_order: "请按顺序回答问题"
en:
  short_story_template: "Short Story Settings Template"
  select_story_template: "Select Story Template"
  no_template: "Do not use story routine template"
  free_create: "Free creation, no restrictions!"
  template_difficulty: "Template Difficulty"
  story_type: "Story Type"
  type: "Type"
  inspiration_helper: "Inspiration Helper"
  template_routine: "Template Routine"
  role_description: "Role Description"
  routine_tip: "Note: The above is a routine description. Please embed the desired story events according to the routine."
  ai_generate: "AI Generate"
  writing_perspective: "Writing Perspective"
  story_style: "Story Style"
  style: "Style"
  reference_word_count: "Reference Chapter Word Count"
  ai_wordcount_tip: "Due to AI algorithm limitations, the generated word count cannot be precisely controlled and can only be kept within a general range."
  creative_guide: "Creative Guide"
  story_elements: "Story Elements"
  element_placeholder: "Optional, separate multiple with commas"
  change_another: "Change Another"
  hot_topics: "Hot Topics"
  hot_placeholder: "Optional, separate multiple with commas"
  other_ideas: "Other Ideas"
  other_ideas_placeholder: "Describe the story you want to create... It can be a simple sentence or a long setting."
  fill_event: "Please fill in the relevant events completely"
  select_story_type: "Please select story type"
  select_perspective: "Please select writing perspective"
  select_style: "Please select story style"
  select_wordcount: "Please select reference chapter word count"
  select_template: "Please select template"
  answer_in_order: "Please answer the questions in order"
</i18n>
<template>
<!-- 短篇 故事设置 模板 -->
  <div>
    <el-row :gutter="10" class="my-1">

      <el-col :span="24" class="">
        <div class="template-box d-flex" v-if="activeItem.id == '-1'">
          <div class="d-flex flex-y-center pointer" @click="setShowDialogDpFlag(true)"  style="background: #FFFFFF;border-radius: 12px;padding: .5rem;border: 1px solid rgba(0,0,0,0.08);">
            <div class="template-icon flex-center" style="border-radius: 12px;width: 5rem;height: 5rem;background: #F3F4FF;">
              <span class="" style="font-size: 40px;color: #FFFFFF;padding-bottom: 8px;">+</span>
            </div>
            <div class="template-tips flex-center" style="height: 4rem;padding-left: 6px;">
              <span style="padding: 0 .5rem;">{{$t('select_story_template')}}</span><i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>

        <div class="template-box d-flex" v-else-if="activeItem.id == '0'" style="margin-bottom: 2rem;">
          <div class="d-flex flex-y-center pointer" @click="setShowDialogDpFlag(true)" style="border-radius: 6px;border: 1px solid #366EF4;width: auto;">
            <div class="template-icon d-flex " style="margin:.5rem;background: linear-gradient( 270deg, #F7F8FF 0%, #E7E9FE 100%);border-radius: 6px;padding: 1rem;flex-direction: column;">
              <span class="field-title" style="padding-bottom: 1rem;">{{$t('no_template')}}</span>
              <span class="field-content" style="">{{$t('free_create')}}</span>
            </div>
            <div class="template-tips flex-center" style="height: 4rem;padding-left: 6px;padding-right: 6px;">
              <span></span><i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>

        <div class="template-box d-flex" style="" v-else>
          <div class="d-flex flex-y-center pointer" @click="setShowDialogDpFlag(true)" style="flex: 1;border-radius: 12px;border: 1px solid #366EF4;width: auto;">
            <div class="model-box" style="padding: .5rem;flex: 1;">
                <div class="model-box-item" style="padding: .5rem 0 .5rem 1rem;border-radius: 6px;">
                    <div class="model-box-item-title">
                      {{activeItem.title}}
                    </div>
                    <el-tooltip placement="top" class="ly-tooltip-class">
                      <div slot="content">
                        <div class="score-box d-flex" style="padding: .5rem  .5rem 0 .5rem;align-items: center;">
                          <div class="score-info d-flex" style="flex-direction: column;margin-right: 1rem;">
                            <div class="score-text" style="font-weight: 400;font-size: 12px;color: #FFFFFF;">
                              {{$t('template_difficulty')}}
                            </div>
                            <div class="score-number" style="font-weight: 600; font-size: 32px;color: rgba(255,255,255,0.9);">
                              {{Number(activeItem.score).toFixed(1)}}
                            </div>
                          </div>
                          <div class="score-star">
                            <div class="model-box-item-score d-flex" style="">
                              <div v-for="number in 5" :key="number" >
                                <img style="width: 16px; height: 16px;" v-if="number <= activeItem.score/2" src="../../assets/star-yellow.png" alt="" />
                                <img style="width: 16px; height: 16px;" v-else-if="number == (activeItem.score/2+0.5)" src="../../assets/star-half.png" alt="" />
                                <img style="width: 16px; height: 16px;" v-else src="../../assets/star-white.png" alt="" />
                              </div>
                            </div>
                            <div class="score-desc" style="font-size: 12px;line-height: 32px;color: #FFFFFF;">
                              {{activeItem.scoreDesc}}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="model-box-item-score d-flex" style="">
                        <div v-for="number in 5" :key="number" >
                          <img style="width: 16px; height: 16px;" v-if="number <= activeItem.score/2" src="../../assets/star-yellow.png" alt="" />
                          <img style="width: 16px; height: 16px;" v-else-if="number == (activeItem.score/2+0.5)" src="../../assets/star-half.png" alt="" />
                          <img style="width: 16px; height: 16px;" v-else src="../../assets/star-white.png" alt="" />
                        </div>
                      </div>
                    </el-tooltip>
                    <div class="model-box-item-tag" style="margin-top: .1rem;">
                      <span class="model-box-item-tag-item" :key="indexTag" v-for="(itemTag,indexTag) in activeItem.tag&&activeItem.tag.split(',')">{{itemTag}}</span>
                    </div>
                </div>
            </div>
            <div class="template-tips flex-center" style="height: 100px;padding-right: .5rem;">
              <span></span><i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>

      </el-col>

      <el-col :span="24" class="my-1" v-if="notTemplateFlag">
        <span class="field-required-pre">*</span><span class="field-title">{{$t('story_type')}}</span>
      </el-col>
      <el-col :span="24" v-if="notTemplateFlag">
        <el-cascader class="custom-select-v1" v-if="storyTiaojian.length>0"
            v-model="articleTypeIdOptions"
            :placeholder="$t('type')"
            :options="storyTiaojian.filter(item1=>item1.code==1)[0].children.filter(item2=>item2.code==7)[0].children"
            @change="$handleChangeArticleTypeId($event, story)"
            :props="{
              expandTrigger: 'hover'
            }"
            :show-all-levels="false"
            filterable></el-cascader>
      </el-col>
    </el-row>

    <!-- 切换模式 -->
    <div class="d-flex flex-center-x" style="margin: 1rem 0;" v-if="activeItem.id!='-1'&&!notTemplateFlag">
      <div class="template-mode d-flex">
        <div class="item-mode pointer" :class="{'active-mode': indexMode==0}" @click="clickItemMode(0)">
          快捷模式
        </div>
        <div class="item-mode pointer" :class="{'active-mode': indexMode==1}" @click="clickItemMode(1)">
          问答模式
        </div>
      </div>
    </div>

    <!-- 快捷模式 -->
    <el-row :gutter="10" class="" v-if="activeItem.id!='-1'&&!notTemplateFlag && indexMode==0" style="background: #FFFFFF;box-shadow: 0px 4px 10px 0px rgba(0,82,217,0.09);border-radius: 20px; padding: 1.5rem;min-height: 400px;">
      <!-- age -->
      <transition name="el-zoom-in-top">
        <el-col :span="24" class="wenti" v-if="wentiFlags[0]||story.ageTag">
          <div class="wenti-q d-flex">
            <div class="wenti-q-prefix">问题：</div>
            <div class="wenti-q-neirong">故事发生在什么时代？</div>
          </div>
          <div class="wenti-a d-flex" v-if="ageTags.length>0">
            <div class="wenti-a-item d-flex flex-y-center" @click="tagItemClick(item,'AGE')" :class="{'wenti-a-item-active': story.ageTag==item.tagText}" v-for="(item, index) in ageTags" :key="index">
              <div>{{item.tagText}}</div>
              <img v-if="item.id&&Number(item.id)>0" @click.stop="onRemoveTag(item)" src="../../assets/writer-delete.png" style="height: 12px;margin-left: 6px;"/>
            </div>
            <div class="wenti-add" @click="onAddTag('AGE')"><img src="../../assets/wenti-a-plus.png" style="height: 14px;"/></div>

          </div>
          <transition name="el-zoom-in-top">
            <div class="wenti-tag-add" v-if="ageInputFlag">
              <div class="wenti-tag-add-input">
                <el-input type="text" v-model="tagTextAdd" class="wenti-tag-add-input">
                </el-input>
              </div>
              <div class="wenti-tag-add-btn">
                <el-button class="custom-button" :disabled="!tagTextAdd" :size="$root.buttonSize" type="primary" @click="addTag('AGE')" >确认</el-button>
              </div>
            </div>
          </transition>
        </el-col>
      </transition>

      <!-- world view -->
      <transition name="el-zoom-in-top">
        <el-col :span="24" class="wenti" style="margin-top: 2rem;" v-if="wentiFlags[1]||story.worldViewTag">
          <div class="wenti-q d-flex">
            <div class="wenti-q-prefix">问题：</div>
            <div class="wenti-q-neirong">你的故事世界设定是什么？</div>
          </div>
          <div class="wenti-a d-flex" v-if="worldViewTags.length>0">
            <div class="wenti-a-item d-flex flex-y-center" @click="tagItemClick(item, 'WORLD_VIEW')" :class="{'wenti-a-item-active': story.worldViewTag==item.tagText}" v-for="(item, index) in worldViewTags" :key="index">
              <div>{{item.tagText}}</div>
              <img v-if="item.id&&Number(item.id)>0" @click.stop="onRemoveTag(item)" src="../../assets/writer-delete.png" style="height: 12px;margin-left: 6px;"/>
            </div>
            <div class="wenti-add" @click="onAddTag('WORLD_VIEW')"><img src="../../assets/wenti-a-plus.png" style="height: 14px;"/></div>
          </div>
          <transition name="el-zoom-in-top">
            <div class="wenti-tag-add" v-if="worldViewInputFlag">
              <div class="wenti-tag-add-input">
                <el-input type="text" @click="addTag('WORLD_VIEW')" v-model="tagTextAdd" class="wenti-tag-add-input">
                </el-input>
              </div>
              <div class="wenti-tag-add-btn">
                <el-button class="custom-button" :disabled="!tagTextAdd" :size="$root.buttonSize" type="primary" @click="addTag('WORLD_VIEW')" >确认</el-button>
              </div>
            </div>
          </transition>
        </el-col>
      </transition>

      <!-- place -->
      <transition name="el-zoom-in-top">
        <el-col :span="24" class="my-1 wenti" style="margin-top: 2rem;" v-if="wentiFlags[2]||story.placeTag">
          <div class="wenti-q d-flex">
            <div class="wenti-q-prefix">问题：</div>
            <div class="wenti-q-neirong">你的故事场景是什么？</div>
          </div>
          <div class="wenti-a d-flex" v-if="placeTags.length>0">
            <div class="wenti-a-item d-flex flex-y-center" @click="tagItemClick(item, 'PLACE')" :class="{'wenti-a-item-active': story.placeTag==item.tagText}" v-for="(item, index) in placeTags" :key="index">
              <div>{{item.tagText}}</div>
              <img v-if="item.id&&Number(item.id)>0" @click.stop="onRemoveTag(item)" src="../../assets/writer-delete.png" style="height: 12px;margin-left: 6px;"/>
            </div>
            <div class="wenti-add" @click="onAddTag('PLACE')"><img src="../../assets/wenti-a-plus.png" style="height: 16px;"/></div>
          </div>
          <transition name="el-zoom-in-top">
            <div class="wenti-tag-add" v-if="placeInputFlag">
              <div class="wenti-tag-add-input">
                <el-input type="text" v-model="tagTextAdd" class="wenti-tag-add-input">
                </el-input>
              </div>
              <div class="wenti-tag-add-btn">
                <el-button class="custom-button" :disabled="!tagTextAdd" :size="$root.buttonSize" type="primary" @click="addTag('PLACE')" >确认</el-button>
              </div>
            </div>
          </transition>
        </el-col>
      </transition>

      <!-- 一个精简问题 -->
      <transition name="el-zoom-in-top">
        <el-col :span="24" class="wenti" style="margin-top: 2rem;" v-if="(wentiFlags[3] && storyTemplateQuestions.length>0)||storyTemplateAnswers[0]||(story.ageTag&&story.worldViewTag&&story.placeTag)">
          <div class="wenti-q d-flex">
            <div class="wenti-q-prefix" v-if="storyTemplateQuestions.length>0&&storyTemplateQuestions[0].title">问题：</div>
            <div class="wenti-q-neirong">{{storyTemplateQuestions.length>0?storyTemplateQuestions[0].title:''}}</div>
          </div>
          <div class="wenti-a d-flex mobile-jingjian" style="line-height: 24px;">
            <LlmSkeleton v-if="isSkeleton" />
            <div v-else class="wenti-a-daa-item" style="position: relative;"
              @click="handleTemplateAnswerEnabled(item)"
              :class="{'wenti-a-daa-item-active': item.id==answerId || item.enableFlag}"
              v-for="(item, index) in storyAnswers" :key="index">
              <div
                v-html="replaceLineBreaks(item.answer)">
              </div>
              <i v-if="item.id==answerId || item.enableFlag" class="el-icon-success" style="position: absolute;top:1rem;right: 1rem;font-weight: bold;color: #0052D9;font-size: 16px;"></i>
            </div>

          </div>
          <div v-if="storyAnswers&&storyAnswers.length>0&&!isSkeleton" class="my-1" style="padding: .25rem;">
            <div class="wenti-add d-flex flex-y-center pointer" style="color: #0052D9;padding: .5rem;" v-if="!regenFlag" @click="regenFlag=true"><img src="../../assets/shortcut-regen.png" style="height: 16px;"/><div style="margin-left: .25rem;">重新生成</div></div>
            <div class="wenti-tag-add" v-if="regenFlag">
              <div class="wenti-tag-add-input">
                <el-input type="text" placeholder="请输入你的想法？几个人？矛盾点？几次转折？人物结局？" v-model="storyContentRequired" class="wenti-tag-add-input">
                </el-input>
              </div>
              <div class="wenti-tag-add-btn">
                <el-button class="custom-button" :disabled="!storyContentRequired" :size="$root.buttonSize" type="primary" @click="genStoryQa" >重新生成</el-button>
              </div>
            </div>
          </div>
        </el-col>
      </transition>
    </el-row>

    <!-- 问答模式 -->
    <el-row :gutter="10" class="ly-border-12"
        v-if="indexMode==1&&!notTemplateFlag && activeItem.id!='-1'"
        style="background: #FFFFFF;padding: 0 .5rem 1rem .5rem;">
      <el-col :span="12" class="my-1">
        <div class="jieshi-box">
          <div class="jieshi-box-title d-flex">
            <img class="img-header" src="../../assets/taolumuban-icon.png" style=""/><span>{{$t('template_routine')}}</span><img class="img-tail" src="../../assets/tishi-icon.png" style=""/>
          </div>
          <el-tooltip placement="top">
            <div slot="content">
              <div style="display: flex;width: 45vw;line-height: 1.5rem;">
                {{activeItem.content}}
              </div>
            </div>
            <div class="jieshi-box-content">
              {{activeItem.content}}
            </div>
          </el-tooltip>
        </div>
      </el-col>
      <el-col :span="12" class="my-1">
        <div class="jieshi-box">
          <div class="jieshi-box-title d-flex">
            <img class="img-header" src="../../assets/juesuesuuoming-icon.png" style=""/><span>{{$t('role_description')}}</span><img class="img-tail" src="../../assets/tishi-icon.png" style=""/>
          </div>
          <el-tooltip placement="top">
            <div slot="content">
              <div style="display: flex;width: 45vw;line-height: 1.5rem;">
                <div v-html="replaceLineBreaks(activeItem.roleDesc)"></div>
              </div>
            </div>
            <div class="jieshi-box-content" v-html="replaceLineBreaks(activeItem.roleDesc)">
            </div>
          </el-tooltip>
        </div>
      </el-col>
      <el-col :span="24" class="">
        <div class="jieshi-box-tishi d-flex">
          <img class="img-disble" src="../../assets/tishi-disable.png" style=""/><span class="">{{$t('routine_tip')}}<a style="color: #366EF4;text-decoration: underline;cursor: text;">{{$t('story_elements')}}</a></span>
        </div>
      </el-col>

      <!-- 问答 -->
      <template v-for="(item, index) in storyTemplateQuestions">
        <el-col :span="24" class="">
          <div class="question-box">
            <div class="question-box-title" v-html="replaceNumber(index,item.title)">
            </div>
            <div class="example-box d-flex" style="flex-direction: column;">
              <div class="question-box-example" >
                {{item.example}}
              </div>
              <div class="question-box-answer d-flex" :class="{'ly-textarea-error-border': item.id == checkQuestionId}">
                <div class="question-box-answer-input d-flex-1">
                  <el-input :class="{'ly-textarea-error': item.id == checkQuestionId}" :placeholder="getPlaceholder(item.id == checkQuestionId)" @input="inputChange(item, index)"
                    v-model="storyTemplateAnswers[index]" type="textarea" clearable :autosize="{ minRows: 1, maxRows: 10 }" show-word-limit class="ly-textarea">
                  </el-input>
                </div>
                <div class="question-box-answer-btn" @click="handleQuestionClick(item)">
                  <img src="../../assets/aigen-icon.png" alt="" srcset="" /><span>{{$t('ai_generate')}}</span>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </template>
    </el-row>

    <el-row :gutter="10" style="padding: 2rem 0;"
      v-if="(activeItem.id != '-1'&&indexMode==1)||indexModeFlag0||activeItem.id == '0'">
      <el-col :span="24" style="">
        <span class="field-required-pre">*</span><span class="field-title">{{$t('writing_perspective')}}</span>
      </el-col>
      <el-col :span="24" style="padding-top: 1rem;" v-if="enums.WritingPerspectiveEnum">
        <el-radio-group v-model="story.writingPerspective">
          <el-radio :border="false" :label="item.name" :key="index" v-for="(item,index) in enums.WritingPerspectiveEnum">{{item.desc}}</el-radio>
        </el-radio-group>
      </el-col>
      <!-- wenfeng -->
      <el-col :span="24" style="padding-top: 2rem;">
        <span class="field-required-pre">*</span><span class="field-title">{{$t('story_style')}}</span>
      </el-col>
      <el-col :span="24" style="padding-top: 1rem;" v-if="storyTiaojian.length>0">
        <el-cascader class="custom-select-v1"
            v-model="articleStyleIdOptions"
            :placeholder="$t('style')"
            :options="storyTiaojian.filter(item1=>item1.code==5)[0].children"
            :props="{ expandTrigger: 'hover' }"
            @change="$handleChangeArticleStyleId($event, story)"
            :show-all-levels="false"
            filterable></el-cascader>
      </el-col>
      <el-col :span="24" style="display: flex;align-items: center;padding-top: 2rem;">
        <span class="field-required-pre">*</span><span class="field-title" style="margin-right: .25rem;">{{$t('reference_word_count')}}</span>
        <el-tooltip placement="top" style="display: inline-block;">
          <div slot="content">
            <div style="">
              {{$t('ai_wordcount_tip')}}
            </div>
          </div>
          <div class="">
            <img style="height: 16px; display: inline-block;margin-top: 3px;" src="../../assets/tishi-icon.png"/>
          </div>
        </el-tooltip>
      </el-col>
      <el-col :span="24" v-if="enums.ArticleOutlineLengthEnum" style="padding-top: 1rem;">
        <el-radio-group v-model="story.storyOutlineLength">
          <el-radio :border="false" :label="item.name" :key="index" v-for="(item,index) in enums.ArticleOutlineLengthEnum">{{item.desc}}</el-radio>
        </el-radio-group>
      </el-col>
    </el-row>

    <!-- {{$t('creative_guide')}} -->
    <el-row :gutter="10" class="my-1"  v-if="notTemplateFlag">

      <el-col :span="24" style="margin-bottom: 1rem;">
        <span class="field-title">{{$t('story_elements')}}</span>
      </el-col>
      <el-col :span="24">
        <el-input type="text" :placeholder="$t('element_placeholder')"
          v-model="story.storyIdeaElement" :rows="1" clearable class="story-idea no-border-input">
        </el-input>
        <div class="d-flex flex-between">
         <div class="story-idea-tag-box">
           <span @click="handleIdeaClick('element', itemHot.name)" class="story-idea-tag-box-tag pointer" :key="index" v-for="(itemHot,index) in synesthesiaElements">{{itemHot.name}}</span>
         </div>
         <div class="pointer get-more" @click="handleIdeaRef('element')">
           <img src="@/assets/random.png" style="width: 12px;padding-right: .25rem;"/><span style="">{{$t('change_another')}}</span>
         </div>
        </div>
      </el-col>

      <el-col :span="24" class="my-1">
        <span class="field-title">{{$t('hot_topics')}}</span><span class="field-required-pre"></span>
      </el-col>
      <el-col :span="24">
        <el-input type="text" :placeholder="$t('hot_placeholder')"
          v-model="story.storyHot" clearable :rows="1" class="story-idea no-border-input">
        </el-input>

        <div class="d-flex flex-between">
          <div class="story-idea-tag-box">
            <span @click="handleIdeaClick('hot', itemHot.content)" class="story-idea-tag-box-tag pointer" :key="index" v-for="(itemHot,index) in hots">{{itemHot.content}}</span>
          </div>
          <div class="pointer get-more" @click="handleIdeaRef('hot')">
            <img src="@/assets/random.png" style="width: 12px;padding-right: .25rem;"/><span style="">{{$t('change_another')}}</span>
          </div>
        </div>
      </el-col>

      <el-col :span="24" class="my-1">
        <span class="field-title">{{$t('other_ideas')}}</span>
      </el-col>
      <el-col :span="24" style="margin-bottom: 1rem;">
        <el-input type="textarea" :placeholder="$t('other_ideas_placeholder')"
          v-model="story.storyIdeaOther" clearable :rows="4" maxlength="2000" show-word-limit class="story-idea no-border-input">
        </el-input>
      </el-col>
    </el-row>

    <StoryDpTemplateDialog v-if="showDialogDpFlag" :enums="enums" ref="dp-template-ref"/>
    <StoryRecommendTemplate v-if="showDialogRecommendFlag" :enums="enums"/>
    <StoryDpQuestionDialog v-if="showDialogDpQuestionFlag && activeQuestion.id" :storyTemplate="activeTemplate" :question="activeQuestion" ref="dp-question-ref"/>
  </div>

</template>
<script>
import * as StoryTemplateQuestionApi from '@/api/storytemplatequestion'
import * as StoryTemplateAnswerApi from '@/api/storytemplateanswer'
import * as StoryCpApi from '@/api/storycp'
import * as StoryTemplateApi from '@/api/storytemplate'
import * as EnumApi from '@/api/enums'
import * as StorySynesthesiaElementApi from '@/api/storysynesthesiaelement'
import StoryDpTemplateDialog from '@/components/StoryIdeaDialog/index_template'
import StoryRecommendTemplate from '@/components/StoryIdeaDialog/recommend_template'
import StoryDpQuestionDialog from '@/components/StoryIdeaDialog/index_question'
import * as StoryHotApi from '@/api/storyhot'
import { mapState, mapMutations} from 'vuex'
import * as ArticleApi from '@/api/article'
import sse from '@/utils/llmstream'
import LlmSkeleton from '@/components/LlmSkeleton'
export default {
  name: 'StoryByTemplate',
  props: {
    enums: {
      type: Object,
      default: {}
    },
    channel: {
      type: String,
      default: 'workspace_index'
    },
  },
  components: {
    StoryDpTemplateDialog,StoryDpQuestionDialog,StoryRecommendTemplate,LlmSkeleton
  },
  data() {
    return {
      activeItem: {id: '-1'},
      isSkeleton: false,
      regenFlag: false,
      indexModeFlag0: false,
      storyAnswers: [],
      storyContentRequired: '',
      indexMode: 0,
      ageTags: [],
      worldViewTags: [],
      placeTags: [],
      ageTagText: '',
      worldViewTagText: '',
      placeTagText: '',
      tagTextAdd: '',
      storyContentRequired: '',
      ageInputFlag: false,
      worldViewInputFlag: false,
      placeInputFlag: false,
      wentiFlags:[true, false, false,false],
      synesthesiaElements:[],
      cps:[],
      hots:[],
      storyTemplates:[],
      question: {},
      storyTemplateQuestions:[],
      storyTemplateAnswers:[],
      storyTemplateTags:[],
      tags: [],
      articleTypeIdOptions: [],
      articleStyleIdOptions: [],
      placeholder: '请填写完整的相关事件',
      checkQuestionId: '',
      answerId: '',
      queryForm: {
        name: '',
        templateType: 'GUANFANG',
        enableFlag: true,
        tag: '',
        current: '',
        size: 100
      },
      rules: {
      }
    }
  },
  mounted() {
    console.log('mounted', this.story);
    if(this.story.id && Number(this.story.id)>0){
      this.articleTypeIdOptions = [this.story.articleTypeId]
      this.articleStyleIdOptions = [this.story.articleStyleId]
      // 存在 story
      this.indexMode=this.story.newFlag?0:1
      this.handleTemplateView()
    }else{
      this.activeItem = {id: '-1'}
      this.setStory({id: '', articleTypeId: null, articleStyleId: null, articleGenType: 'GEN_BY_ZHIHU', writingPerspective: 'FIRST_PERSON', storyOutlineLength: 'Length_1', storyCp: '', storyHot: '', storyIdeaElement: ''})
    }

    this.handleIdeaRef('element')
    this.handleIdeaRef('hot')
    this.handleIdeaRef('cp')

    window.addEventListener('resize', this.forceUpdate);

  },
  computed: {
    ...mapState(['user', 'story', 'showDialogDpFlag', 'showDialogDpQuestionFlag','showDialogRecommendFlag',
     'activeQuestion', 'activeTemplate', 'storyTiaojian']),
    notTemplateFlag() {
      console.log('notTemplateFlag activeItem:', this.activeItem)
      return this.activeItem.id && Number(this.activeItem.id)==0;
    },
    showHeader() {
      return window.innerWidth <= 768
    },
    nextBtnDisabled() {
      console.log('nextBtnDisabled activeItem:', this.activeItem, this.storyTemplateAnswers)
      return this.activeItem.id == '-1'? true : (this.storyTemplateAnswers.some(item => !item || item.trim() == '') && Number(this.activeItem.id)>0)
    },
  },
  created() {
    console.log('created');
  },
  methods: {
    ...mapMutations(['setStory', 'setShowDialogDpFlag', 'setShowDialogRecommendFlag',
                    'setShowDialogDpQuestionFlag', 'setActiveQuestion', 'setActiveTemplate']),
    clickItemMode(indexMode) {
      this.indexMode = indexMode
      this.routerQuestion()
    },
    setIndexModeFlag0(){
      this.indexModeFlag0 = (this.activeItem.id != '-1'&&this.indexMode==0&&this.story.ageTag&&this.story.worldViewTag&&this.story.placeTag&&this.storyTemplateAnswers.length>0&&this.storyTemplateAnswers[0]!='');
      console.log('indexModeFlag0:', this.indexModeFlag0)
    },
    tagItemClick(item,tagType){
      let params = {id: this.story.id}
      if(tagType=='AGE'){
        this.ageTagText = item.tagText
        this.story.ageTag = item.tagText
        params.ageTag = item.tagText
        this.wentiFlags[0]=true
        this.wentiFlags[1]=true
      }else if(tagType=='WORLD_VIEW'){
        this.worldViewTagText = item.tagText
        this.story.worldViewTag = item.tagText
        params.worldViewTag = item.tagText
        this.wentiFlags[1]=true
        this.wentiFlags[2]=true
      }else if(tagType=='PLACE'){
        this.placeTagText = item.tagText
        this.story.placeTag = item.tagText
        params.placeTag = item.tagText
        this.wentiFlags[2]=true
        this.wentiFlags[3]=true
        if(this.storyTemplateQuestions.length>0 && this.storyAnswers.length==0){
          this.genStoryQa()
        }
      }
      this.resetTagBtnFlag()
      params.newFlag=this.story.newFlag
      ArticleApi.update(params).then(res => {
        let data = res.data.data
        this.setStory(data)
        this.setIndexModeFlag0()
        if(!this.indexModeFlag0){
          this.$parent.scrollToBottom()
        }
      })

    },
    resetTagBtnFlag(){
      this.ageInputFlag=false
      this.worldViewInputFlag=false
      this.placeInputFlag=false
      this.tagTextAdd = ''
    },
    onRemoveTag(item) {
      this.$confirm('', this.$i18n.locale === 'zh' ? '确定删除吗?' : 'Are you sure you want to delete?', {
        confirmButtonText: this.$i18n.locale === 'zh' ? '确定' : 'Confirm',
        cancelButtonText: this.$i18n.locale === 'zh' ? '取消' : 'Cancel',
        center: true
      }).then(() => {
        StoryTemplateApi.removeTag(item.id).then(res => {
          this.myTags(item.tagType)
        });
      }).catch((e) => {console.log('error', e)});
    },
    onAddTag(tagType){
      this.resetTagBtnFlag()
      if(tagType=='AGE'){
        this.ageInputFlag=true
      }else if(tagType=='WORLD_VIEW'){
        this.worldViewInputFlag=true
      }else if(tagType=='PLACE'){
        this.placeInputFlag=true
      }
    },
    addTag(tagType){
      this.createTag(tagType)
    },
    replaceNumber(index, text){
      if(!text) {
        return ''
      }
      // ① ② ③
      let e1 = this.extractTextBetween(text, '①', '②')
      let es = []
      es.push('<el-tooltip placement="top">')

      es.push('<div slot="content">')
      es.push(e1)
      es.push('</div>')

      es.push('<span style="color:#366EF4;">①</span>')
      es.push('</el-tooltip>')
      let tip1 = es.join()

      let e2 = this.extractTextBetween(text, '②' ,'③')
      es = []
      es.push('<el-tooltip placement="top">')

      es.push('<div slot="content">')
      es.push(e2)
      es.push('</div>')

      es.push('<span style="color:#366EF4;">②</span>')
      es.push('</el-tooltip>')
      let tip2 = es.join()

      let e3 = text.substr(text.indexOf('③')+1)
      es = []
      es.push('<el-tooltip placement="top">')

      es.push('<div slot="content">')
      es.push(e3)
      es.push('</div>')

      es.push('<span style="color:#366EF4;">③</span>')
      es.push('</el-tooltip>')
      let tip3 = es.join()

      return text?'<span class="field-required">*</span>'+(index+1)+'. '
      +text.trim().replace('①', '<span style="color:#366EF4;">①</span>')
      .replace('②', '<span style="color:#366EF4;">②</span>')
      .replace('⑩', '<span style="color:#366EF4;">⑩</span>')
      .replace('④', '<span style="color:#366EF4;">④</span>')
      .replace('⑤', '<span style="color:#366EF4;">⑤</span>')
      .replace('⑥', '<span style="color:#366EF4;">⑥</span>')
      .replace('⑦', '<span style="color:#366EF4;">⑦</span>')
      .replace('⑧', '<span style="color:#366EF4;">⑧</span>')
      .replace('⑨', '<span style="color:#366EF4;">⑨</span>')
      .replace('③', '<span style="color:#366EF4;">③</span>'):'';
      // return text?'<span class="field-required">*</span>'+(index+1)+'. '+text.trim().replace('①', tip1).replace('②', tip2).replace('③', tip3):'';
    },
    replaceNumber2(text){
      // ①②③④⑤⑥⑦⑧⑨⑩
      return text?text.trim().replace('①', '').replace('②', '').replace('③', '').replace('⑩', '')
      .replace('④', '').replace('⑤', '').replace('⑥', '').replace('⑦', '').replace('⑧', '').replace('⑨', ''):'';
    },
    extractTextBetween(str, startChar, endChar) {
      //str?str.replace(/\\n/g, '\n').replace(/\n/g, '<br>'):"";
      // 构建正则表达式，使用捕获组来提取两个字符之间的文本
      const regex = new RegExp(`${startChar}(.*?)${endChar}`);
      // 使用 match 方法搜索字符串
      const match = str.match(regex);
      // 如果找到匹配项，返回第一个捕获组的内容（索引 1）
      return match ? match[1] : null;
    },
    splitByEmptyLines(str) {
      // 正则表达式匹配一个或多个换行符，可能前后有空白字符
      // const regex = /(\s*\n\s*)+/;
       // 正则表达式匹配两个换行符之间没有其他字符的情况
        const regex = /\n\s*\n/;
      return str?str.split(regex):'';
    },
    replaceLineBreaks(str) {
      return str?str.replace(/\\n/g, '\n').replace(/\n/g, '<br>'):"";
    },
    initStyle(){
      if(Number(this.story.articleStyleId) == 0) {
        this.story.articleStyleId = null
        this.setStory(this.story)
      }
      if(Number(this.story.articleTypeId) == 0) {
        this.story.articleTypeId = null
        this.setStory(this.story)
      }
    },
    inputChange(item, index){
      //创建 or 更新 answer
      StoryTemplateAnswerApi.create({fromType: 'qa_answer_title_change', questionId: item.id, storyId: this.story.id,
                                      templateId: this.story.storyTemplateId, accountId:this.user.id,
                                      answer: this.storyTemplateAnswers[index]}).then(res => {
        let result = res.data.data;
        this.checkQuestionId = ''
      });
    },
    handleOkFromHomePage(){
      this.activeItem = this.activeTemplate
      this.createOrUpdateStroy(4);
      this.story.storyTemplateId = this.activeItem.id
      this.setStory(this.story)
    },
    createOrUpdateStroy(from) {//0-下一步 1-AI生成 2-开始生成 3-重新生成 4-确认模板

      if(from == 0) {
        if ((!this.story.articleTypeId || !this.story.articleTypeId.trim() || Number(this.story.articleTypeId)==0) && this.notTemplateFlag) {
            this.$message.error(this.$t('select_story_type'));
            return false;
        }
        if (!this.story.writingPerspective || !this.story.writingPerspective.trim()) {
            this.$message.error(this.$t('select_perspective'));
            return false;
        }
        if (!this.story.articleStyleId || !this.story.articleStyleId.trim() || Number(this.story.articleStyleId)==0) {
            this.$message.error(this.$t('select_style'));
            return false;
        }
        if (!this.story.storyOutlineLength || !this.story.storyOutlineLength.trim()) {
            this.$message.error(this.$t('select_wordcount'));
            return false;
        }
        if (!this.notTemplateFlag && (!this.story.storyTemplateId || this.story.storyTemplateId == '0')) {
            this.$message.error(this.$t('select_template'));
            return false;
        }
        if(this.story.stepNumber<1){
          this.story.stepNumber = 1
        }
        if (this.notTemplateFlag) {

        }else{
          let questionIndex = 0
          this.storyTemplateAnswers.forEach((item, index) => {
            console.log('answer', index, item);
            if(!item || item == ''){
              questionIndex = index
              this.checkQuestionId = this.storyTemplateQuestions.length>questionIndex?this.storyTemplateQuestions[questionIndex].id:''
              this.$message.warning(this.getPlaceholder(true))
              throw new Error('eixt loop');
            }
          })
        }

      }else if(from == 1){

      }else if(from == 2){

      }else if(from == 3){

      }else if(from == 4){
        // isLoading
        this.$parent.isLoading = false
      }


      if (this.notTemplateFlag) {
          this.story.storyTemplateId = '0'
      }else{
        this.story.storyCp = ''
        this.story.storyHot = ''
        this.story.storyIdeaElement = ''
        this.story.storyIdeaOther = ''
      }

      let params = {}
      if(this.notTemplateFlag){// 不使用模板
        params = {
          id: this.story.id,
          articleType: this.story.articleType,
          articleTypeId: this.story.articleTypeId,
          articleStyle: this.story.articleStyle,
          articleStyleId: this.story.articleStyleId,
          storyOutlineLength: this.story.storyOutlineLength,
          writingPerspective: this.story.writingPerspective,
          storyHot: this.story.storyHot,
          storyIdeaElement: this.story.storyIdeaElement,
          storyIdeaOther: this.story.storyIdeaOther,
          storyTemplateId: 0,
          stepNumber: 1
        }
      }else{// 模板模式
        params = {
          id: this.story.id,
          articleStyle: this.story.articleStyle,
          articleStyleId: this.story.articleStyleId,
          storyOutlineLength: this.story.storyOutlineLength,
          writingPerspective: this.story.writingPerspective,
          storyTemplateId: this.activeItem.id,
          stepNumber: 1
        }
      }
      console.log('params', params,'story', this.story);

      if(this.story.id && Number(this.story.id)>0){

        if(this.story.stepNumber<1){
          params.stepNumber = 1
        }else{
          params.stepNumber = this.story.stepNumber
        }

        // 存在story
        console.log('update params=', params);
        // return false
        ArticleApi.update(params).then(res => {
          let data = res.data.data
          this.setStory(data)
          this.goNext(from)
        })
      }else{
        console.log('create story=', this.story);
        // return false
        ArticleApi.create(this.story).then(res => {
            if(res.data.code == 0){
              let data = res.data.data
              console.log('new dp story', this.story)
              this.setStory(data)
              this.goNext(from)
            }else{
              this.$message.error(res.data.msg);
            }
        })
      }
    },
    goNext(from){
      this.initStyle()
      if(from == 0){
        setTimeout(()=>{
          this.$router.push('/workspace/gen1');
        }, 300)
      }else if(from == 4){
        this.routerQuestion()
      }
    },
    routerQuestion(){
      if(this.story.storyTemplateId && Number(this.story.storyTemplateId) == 0){
        return false
      }
      this.storyTemplateAnswers = []
      if(this.indexMode==1){
        this.story.newFlag=false
        this.handeTemplateQuestion()
      }else if(this.indexMode==0){
        this.story.newFlag=true
        this.handeTemplateQuestionShortcut()
      }
      this.setStory(this.story)
    },
    handeTemplateQuestion(){
      console.log('detail question', this.indexMode);
      if(!this.user.id || !this.story.id){
        return false
      }
      let templateId = this.activeItem.id
      StoryTemplateQuestionApi.page({templateId, accountId:this.user.id, storyId:this.story.id,size: 20}).then(res => {
        let result = res.data.data;
        this.storyTemplateQuestions = result.records
        // 初始化 answer
        this.storyTemplateQuestions.forEach((item, index) => {
          if(item.answerVo && item.answerVo.answer){
            this.storyTemplateAnswers[index] = item.answerVo.answer
          }else{
            this.storyTemplateAnswers[index] = ''
          }
        })
      });
    },
    handeTemplateQuestionShortcut(){
      console.log('shortcut question', this.indexMode);
      if(!this.user.id || !this.story.id){
        return false
      }
      let templateId = this.activeItem.id
      StoryTemplateQuestionApi.page({templateId, shortcutFlag: true, accountId:this.user.id, storyId:this.story.id,size: 20}).then(res => {
        let result = res.data.data;
        this.storyTemplateQuestions = result.records
        if(this.storyTemplateQuestions.length>0){
          this.question = this.storyTemplateQuestions[0]
        }

        // 初始化 answer
        this.storyTemplateQuestions.forEach((item, index) => {
          if(item.answerVo && item.answerVo.answer){
            this.storyTemplateAnswers[index] = item.answerVo.answer
          }else{
            this.storyTemplateAnswers[index] = ''
          }
        })
        this.myTags('AGE')
        this.myTags('WORLD_VIEW')
        this.myTags('PLACE')
        // 精简问题
        this.handleTemplateAnswerPage()
      });
    },
    handleTemplateView(){
      if(this.story.storyTemplateId && Number(this.story.storyTemplateId) == 0){
        this.activeItem = {id: '0'}
        return false
      }
      StoryTemplateApi.view(this.story.storyTemplateId).then(res => {
        let result = res.data.data;
        if(result){
          this.activeItem = result
          this.setActiveTemplate(result)
          // init question
          this.routerQuestion()

        }else{
          this.activeItem = {id: '0'}
        }
      });
    },
    handleTemplateAnswerPage(){
      if(!this.user.id || !this.story.id){
        return false
      }
      StoryTemplateAnswerApi.page({questionId: this.question.id, aigcFlag: true, shortcutFlag: true, accountId: this.user.id, storyId: this.story.id, size: 2}).then(res => {
        let result = res.data.data;
        this.storyAnswers = result.records;
        if(this.storyAnswers.length > 0){
          this.storyContentRequired = this.storyAnswers[0].storyContentRequired
        }
      });
      this.setIndexModeFlag0()
    },
    myTags(tagType){
      let params = {
        templateId: this.story.storyTemplateId,
        tagType: tagType
      }
      StoryTemplateApi.myTags(params).then(res => {
        let result = res.data.data;
        if(tagType=='AGE'){
          this.ageTags = result;
          this.ageTagText = this.tagTextAdd
        }else if(tagType=='WORLD_VIEW'){
          this.worldViewTags = result;
          this.ageTagText = this.tagTextAdd
        }else if(tagType=='PLACE'){
          this.placeTags = result;
          this.ageTagText = this.tagTextAdd
        }
        this.resetTagBtnFlag()
      });
    },
    createTag(tagType){
      let params = {
        templateId: this.story.storyTemplateId,
        tagText: this.tagTextAdd,
        tagType: tagType
      }
      StoryTemplateApi.createTag(params).then(res => {
        this.myTags(tagType)
      });
    },
    handleIdeaRef(flag) {
      if(flag == 'element') {
        StorySynesthesiaElementApi.page({size: 100}).then(res => {
          let result = res.data.data;
          const shuffledArray = this.shuffleArray([...result.records])
          this.synesthesiaElements = shuffledArray.slice(0, 4);
          // this.synesthesiaElements = result.records
        });
      }else if(flag == 'hot') {
        StoryHotApi.page({size: 100}).then(res => {
          let result = res.data.data;
          const shuffledArray = this.shuffleArray([...result.records])
          this.hots = shuffledArray.slice(0, 4);
          // this.synesthesiaElements = result.records
        });
      }else if(flag == 'cp') {
        StoryCpApi.page({size: 100}).then(res => {
          let result = res.data.data;
          const shuffledArray = this.shuffleArray([...result.records])
          this.cps = shuffledArray.slice(0, 4);
          // this.synesthesiaElements = result.records
        });
      }
    },
    getPlaceholder(flag) {
      return flag ? this.$t('answer_in_order') : this.$t('fill_event');
    },
    handleQuestionClick(question) {//AI 生成
      // 控制：确保前面的问题已经回答
      let questionIndex = 0
      this.storyTemplateAnswers.forEach((item, index) => {
        if(index < question.orderNumber-1 && (!item || !item.trim())){
          questionIndex = index
          this.checkQuestionId = this.storyTemplateQuestions[questionIndex].id
          this.$message.warning(this.getPlaceholder(true))
          throw new Error('eixt loop');
        }
      })

      this.createOrUpdateStroy(1)
      console.log('handleQuestionClick question=', question);
      this.setActiveQuestion(question)

      this.setShowDialogDpQuestionFlag(true);
    },
    handleIdeaClick(flag, text) {
      console.log('flag, text', flag, text);
      if(flag == 'element') {
        if(!this.story.storyIdeaElement){
          this.story.storyIdeaElement = text
        }else if(this.story.storyIdeaElement.indexOf(text) == -1){
          this.story.storyIdeaElement = this.story.storyIdeaElement +  ',' + text
        }
      }else if(flag == 'hot') {
        if(!this.story.storyHot){
          console.log('flag, text', flag, text);
          this.story.storyHot = text
          console.log('storyHot', this.story.storyHot);
          this.setStory(this.story)
        }else if(this.story.storyHot.indexOf(text) == -1){
          console.log('flag, text', flag, text);
          this.story.storyHot = this.story.storyHot +  ',' + text
        }
      }else if(flag == 'cp') {
        if(!this.story.storyCp){
          this.story.storyCp = text
        }else if(this.story.storyCp.indexOf(text) == -1){
          this.story.storyCp = this.story.storyCp +  ',' + text
        }
      }
    },
    shuffleArray(array) {
        for (let i = array.length - 1; i > 0; i--) {
            // 生成从0到i的随机索引
            const j = Math.floor(Math.random() * (i + 1));
            // 交换元素
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    },
    handleTemplateAnswerEnabled(item){
      this.answerId = item.id
      this.storyAnswers.forEach((item, index)=>{
        item.enableFlag = false
      })
      StoryTemplateAnswerApi.update({id: item.id, fromType: 'qa_answer_choose', questionId: this.question.id, accountId: this.user.id, storyId: this.story.id})
      .then(res => {
        this.checkQuestionId = this.question.id
        this.storyTemplateAnswers[0]=item.answer
        this.setIndexModeFlag0()
        this.$parent.scrollToBottom(5)
      });
    },
    removeHtmlTagsAndReplaceBrWithNewline(htmlString) {
      // console.log('html', htmlString)
      // 将 <br> 替换为换行符
      let newlineString = htmlString.replace(/(?=\S)<br\s*\/?>/gi, '');
      const regexP = /<p>(.*?)<\/p>/g;
      newlineString = newlineString.replace(regexP, (match, content) => {
        return `${content}\n`; // 保留内容并在其后追加换行符
      });
      // 去除 HTML 标签
      let noHtmlString = newlineString.replace(/<[^>]*>?/gm, '');
      console.log('remove html tag', noHtmlString)
      return noHtmlString;
    },
    normalizeAnswerNumbering(text) {
      if (!text) {
        return ''
      }
      return text
        .replace(/\r\n?/g, '\n')
        .replace(/([。！？!?；;])\s*((?:[1-9]|1[0-9])(?:[.．、)）](?!\d)\s*|(?=《)))/g, '$1\n$2')
        .replace(/([^\n])\s+((?:[1-9]|1[0-9])(?:[.．、)）](?!\d)\s*|(?=《)))/g, '$1\n$2')
    },
    extractAnswers(answers) {
      let text = this.normalizeAnswerNumbering(this.removeHtmlTagsAndReplaceBrWithNewline(answers?answers:''))
       const lines = text.split(/\r?\n/);
       const outlineNumber = [];
       let answersPre = []
       let currentAnswer = null
       let expectedNumber = 1

       // 支持 “1”, “1.”, “1、”, “1《标题》” 等编号格式，并忽略编号前的模型说明文本
       lines.forEach((line) => {
         const matches = line.match(/^\s*(\d{1,2})(?:[.．、)）]\s*|\s+)?(.*)$/)
         if (matches) {
           const number = parseInt(matches[1], 10)
           const content = matches[2] ? matches[2].trim() : ''
           if (number === 1) {
             currentAnswer = content ? [content] : []
             outlineNumber.splice(0, outlineNumber.length, number)
             answersPre.splice(0, answersPre.length)
             expectedNumber = 2
             return
           }
           if (number === expectedNumber && currentAnswer !== null) {
             answersPre.push(currentAnswer.join('\n').trim())
             outlineNumber.push(number)
             currentAnswer = content ? [content] : []
             expectedNumber += 1
             return
           }
         }
         if (currentAnswer !== null) {
           currentAnswer.push(line)
         }
       })
       if (currentAnswer !== null) {
         answersPre.push(currentAnswer.join('\n').trim())
       }
       console.log('outlineNumber -------------- ' + outlineNumber);
       // console.log('answersPre -------------- ' + answersPre);
       return answersPre.filter(item => item && item.trim() !== '');
    },
    genStoryQa() {
        this.isSkeleton = true
        this.$parent.scrollToBottom()
        this.question = this.storyTemplateQuestions[0]
        let params = {}
        params.articleId = this.story.id
        params.articleGenType = this.story.articleGenType
        params.questionTitle = this.replaceNumber2(this.question.title)
        params.questionId = this.question.id
        params.storyTemplateId = this.question.templateId
        params.storyContentRequired = this.storyContentRequired
        params.storyAgeTag = this.story.ageTag
        params.storyWorldViewTag = this.story.worldViewTag
        params.storyPlaceTag = this.story.placeTag
        params.storyQaHistory = this.findQaHistory()
        console.log('params=', params)
        sse("1843129344223019010", params, this.handleStoryTitleMsg).then((result)=>{
          console.log('result', result);
          this.$parent.scrollToBottom()
          let temp = result
          result = this.extractAnswers(result)
          if(temp != '' && (!result || result == '' || result.length == 0)){
            this.isSkeleton = false
            this.$message.warning(this.$t('json_error'))
            return
          }
          StoryTemplateAnswerApi.create({
              titles: result,
              templateId: this.question.templateId,
              storyId: this.story.id,
              questionId: this.question.id,
              aigcFlag: true,
              storyContentRequired: this.storyContentRequired,
              fromType: 'qa_answer_titles_shortcut'})
          .then(res => {
              if(res.data.code == 0){
                let data = res.data.data
                console.log('answer=', data)
                this.storyAnswers = data.answers
              }else{
                this.$message.error(res.data.msg);
              }
              this.isSkeleton = false
          })
        }).catch(error => {
          // 处理错误
          console.error(error);

          this.isSkeleton = false;
        });
    },
    findQaHistory(){
      let questions = this.storyTemplateQuestions
      let answers = this.storyTemplateAnswers
      console.log('findQaHistory ', questions, answers);
      let history = []
      questions.forEach((item,index) => {
        history.push('Q'+(index+1)+':'+this.replaceNumber2(item.title))
        history.push('A'+(index+1)+':'+this.replaceNumber2(answers[index]))
      })
      console.log('findQaHistory ', history);
      return history.join('\n')
    },
    handleStoryTitleMsg(msg){
      // console.log('title', msg);
    },
    forceUpdate() {
      this.$forceUpdate(); // 强制重新渲染，以更新计算属性
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.forceUpdate);
  },
}
</script>

<style scoped lang="scss">
$tagMT: .5rem;
.ly-textarea {
  /deep/ .el-textarea__inner {
      border: none;
      outline: none;
      box-shadow: none;
      background: #FFFFFF !important;
      text-align: justify;
      padding: .5rem;
      line-height: 2;
  }
  /deep/ .el-textarea__inner:hover,
  /deep/ .el-textarea__inner:focus {
      border-color: transparent;
  }
}
.ly-textarea-error {
  /deep/ .el-textarea__inner::placeholder {
    color: #ff0000; /* 红色 */
    // font-size: 14px; /* 根据需要调整字体大小 */
    opacity: 0.5; /* 降低透明度 */
    // border: 1px solid #ff0000;
  }
}
.ly-textarea-error-border {
  border: 1px solid #ff0000 !important;
}
.no-border-input {
  background: #FFFFFF;
  border-radius: 6px 6px 6px 6px;
  border: 1px solid #DCDCDC;
}
.story-idea-tag-box {
  margin-top: $tagMT;
  &-tag {
    display: inline-block;
    background: #F2F3FF;
    border-radius: 12px;
    font-weight: 400;
    font-size: 12px;
    color: #242424;
    padding: .25rem 1rem;
    margin: 0 .5rem .5rem 0;
    white-space: nowrap;
  }
}
.get-more {
  font-size: 12px;
  color: #0052D9;
  white-space: nowrap;
  margin-top: $tagMT;
}
/* 全局滚动条轨道的padding */
.model-box::-webkit-scrollbar-track {
  background-color: transparent;
  // padding: 20px 0; /* 上下padding */
  margin: 1rem 0;
}
/* 滚动条的样式 */
.model-box::-webkit-scrollbar {
  height: 10px;
  margin: 1rem 0;
  background-color: transparent;
}
.model-box::-webkit-scrollbar-thumb {
  background-color: rgba(54,110,244,0.1);
}
.template-box {
  height: 100px;
}
/* 定义 CSS 变量 */
.custom-placeholder .el-input__inner {
  --placeholder-color: #ff0000; /* 红色 */
}
/* 使用 CSS 变量 */
.custom-placeholder .el-input__inner::placeholder {
  color: var(--placeholder-color);
}

/* 定义 CSS 变量 */
.custom-textarea-placeholder .el-textarea__inner {
  --placeholder-color: #ff0000; /* 红色 */
  --placeholder-font-size: 14px; /* 字体大小 */
  --placeholder-opacity: 0.5; /* 透明度 */
}
/* 使用 CSS 变量 */
.custom-textarea-placeholder .el-textarea__inner::placeholder {
  color: var(--placeholder-color);
  font-size: var(--placeholder-font-size);
  opacity: var(--placeholder-opacity);
}
.example-box {

}
.example-box:hover .question-box-example{
   opacity: 1;
   height: auto;
}
.question-box {
  margin-top: 2rem;
  &-title {
    font-weight: 600;
    font-size: 16px;
    color: #000000;
    line-height: 1.5rem;
  }
  &-example {
    background: #FFFFFF;
    color: #366EF4;
    font-size: 12px;
    padding: .5rem 0;
    opacity: 0;
    height: 0;
  }
  &-answer {
    display: flex;
    align-items: center;
    background: #FFFFFF;
    border-radius: 6px 6px 6px 6px;
    border: 1px solid #E5E7FC;
    &-input {

    }
    &-input:hover + .question-box-example{
      opacity: 1;
    }
    &-btn {
      display: flex;
      align-items: center;
      font-weight: 600;
      font-size: 16px;
      color: rgba(0,0,0,0.6);
      padding-right: .5rem;
      cursor: pointer;
      img {
        width: 28px;
        height: 28px;
      }
    }
    &-btn:hover {
      color: #366EF4;
    }
  }
  &-answer:hover {
    border: 1px solid #366EF4;
  }
}
.hidden-element {
  opacity: 0;
  transition: opacity 0.3s;
  pointer-events: none; /* 防止干扰input元素的点击事件 */
}
.trigger-input:hover + .hidden-element {
  opacity: 1;
}

.jieshi-box {
  background: linear-gradient(270deg, #F3F4FF 95%, #E8EAFF 100%);
  border-radius: 6px;
  padding: 1rem;
  &-title{
    font-weight: 600;
    font-size: 18px;
    color: rgba(0,0,0,0.8);
    align-items: center;
    .img-header {
      width: 24px;
      height: 24px;
      margin-right: .5rem;
    }
    .img-tail {
      width: 18px;
      height: 18px;
      margin-left: .5rem;
    }
  }
  &-content{
    font-weight: 400;
    font-size: 12px;
    color: rgba(0,0,0,0.81);
    padding: .5rem 0;
    line-height: 1.5;
    height: 4.5rem;
    -webkit-line-clamp: 4; /* 要显示的行数 */
    -webkit-box-orient: vertical;
    overflow: hidden;
    // text-overflow: ellipsis; /* 超出部分显示省略号 */
    display: -webkit-box;
  }
  &-content:hover {
    overflow: auto;
  }
  &-tishi{
    align-items: center;
    font-weight: 400;
    font-size: 12px;
    color: rgba(0,0,0,0.4);
    .img-disble {
      width: 18px;
      height: 18px;
      margin-right: .5rem;
    }
  }
}
.more-btn {
  display: none; /* 默认不显示 */
}
.model-box {
  // margin: .5rem;
  &-item {
    // width: 14.5rem;
    // padding: 1rem;
    background: linear-gradient( 270deg, #F3F4FF 0%, #E8EAFF 100%);
    border-radius: 14px;
    box-sizing: border-box; /* 边框计算在宽度内 */
    background: linear-gradient( 270deg, #F3F4FF 0%, #E8EAFF 100%);
    overflow: hidden;
    color: #303133;
    &-title {
      font-weight: 600;
      font-size: 1rem;
      color: rgba(0,0,0,0.9);
    }
    &-content {
      // font-size: .9rem;
      // color: rgba(0,0,0,0.6);
      // line-height: 1.25rem;
      // text-align: justify;
      // // margin-top: 1rem;
      // margin-bottom: 2rem;
    }
    &-tag {
      &-item{
        display: inline-block;
        background: #F2F3FF;
        border-radius: 12px;
        font-weight: 400;
        font-size: 12px;
        color: #366EF4;
        padding: .25rem 1rem;
        margin-right: .5rem;
        white-space: nowrap;
      }
    }
  }
}
.multiline-ellipsis {
  position: relative; /* 为伪元素定位做准备 */
  max-height: 6em; /* 根据内容和行高设置最大高度，这里假设每行2em */
  overflow: hidden; /* 隐藏溢出的内容 */
  line-height: 1.25em; /* 设置行高，与最大高度保持一致 */
  text-align: justify; /* 文本两端对齐 */
  // padding-right: 20px; /* 为省略号留出空间 */
}

.multiline-ellipsis::after {
  content: '...';
  text-align: right;
  position: absolute;
  bottom: 0;
  right: 0;
  color: #FFFFFF;
  padding-left: 40px; /* 渐变背景的长度 */
  background: linear-gradient(to right, transparent, white 50%);
  /* 渐变背景从透明到白色，覆盖超出的文本 */
}
.ellipsis4 {
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
}

.custom-select-v1 {
  /deep/ .el-input__inner {
    border-radius: 20px;
    height: 1.75rem;
    line-height: 1.75rem;
    font-size: 12px;
    background: #FFFFFF;
    border: 1px solid #EBEEF5 !important;
  }
  /deep/ .el-input__suffix {
    height: 1.75rem;
    line-height: 1.75rem;
    font-size: 12px;
    display: flex;
    align-items: center;
  }
  /deep/ .el-input--suffix {
    height: 1.75rem;
    line-height: 1.75rem;
    font-size: 12px;
    display: flex;
    align-items: center;
  }
}
.field-content {
  color: rgba(0,0,0,0.6);
}
/deep/ .el-input__inner {
    border: none; /* 去除边框 */
    outline: none; /* 去除聚焦时的轮廓 */
    box-shadow: none; /* 去除阴影 */
    background: transparent;
}
/deep/ .el-select {
    background: #ffffff;
}
.template-mode {
  background: #F2F3FF;
  font-weight: 500;
  font-size: 14px;
  border-radius: 20px;
  .item-mode {
    border-radius: 20px;
    color: rgba(0,0,0,0.25);
    padding: .5rem 2rem;
  }
  .active-mode{
    color: #366EF4;
    background: #E5E7FC;
  }
}
.wenti {
  .wenti-q {
    font-weight: 600;
    font-size: 1rem;
    .wenti-q-prefix {
      color: #366EF4;
    }
  }
  .wenti-a {
    margin-top: 1rem;
    font-size: 14px;
    display: flex;
    gap: .75rem;
    flex-wrap: wrap;
    .wenti-a-item {
      cursor: pointer;
      background: #F2F3FF;
      border-radius: 10px;
      padding: .5rem 1.5rem;
      border: 1px solid #ffffff;
      color: #242424;
    }
    .wenti-a-item-active,.wenti-a-item:hover {
      background: #FFFFFF;
      border: 1px solid #366EF4;
      color: #366EF4;
      font-weight: 600;
    }
    .wenti-add {
      cursor: pointer;
      padding: .25rem;
      background: #F2F3FF;
      border-radius: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #ffffff;
    }
    .wenti-add:hover {
      border: 1px solid #366EF4;
    }

    .wenti-a-daa-item {
      cursor: pointer;
      background: #F2F3FF;
      border-radius: 12px;
      padding: 2rem 1rem;
      border: 1px solid #ffffff;
      color: rgba(0,0,0,0.5);
      font-size: 14px;
      text-align: justify;
    }
    .wenti-a-daa-item-active,.wenti-a-daa-item:hover {
      border: 1px solid #366EF4;
      color: rgba(0,0,0,0.81);
    }
  }
  .wenti-tag-add {
    display: flex;
    align-items: center;
    border-radius: 12px 12px 12px 12px;
    border: 1px solid #366EF4;
    padding: .25rem 1rem;
    margin-top: 1rem;
    .wenti-tag-add-input {
      border: none;
      outline: none;
      flex: 1;
    }
  }
}
@media (max-width: 768px) {
  .mobile-jingjian{
    flex-wrap: wrap;
  }
}
@media (min-width: 768px) {
  .mobile-jingjian{
    flex-wrap: nowrap !important;
  }
}
</style>
<style>
.el-tooltip__popper {
  background: rgba(0,0,0,0.8) !important;
  border-radius: 16px !important;
}
.el-tooltip__popper[x-placement^=top] .popper__arrow:after{
    border-top-color:  rgba(0,0,0,0.8) !important;
}
</style>
